import { Components } from '@mui/material';

export default {
  defaultProps: {
    variant: 'standard',
  },
} as Components['MuiSelect'];
